import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { User } from '../../../..//model/user';
import { ProtocolReportFilter } from '../../../../model/attachment';
import { LangFlag, TranslationService } from '../../../../services/translation.service';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProtocolQ, ProtocolStatus } from '../../../../model/protocol';
import { ProtocolQService } from '../../../../services/protocolQ.service';
import { UsersService } from '../../../../services/users.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ProtocolUtils } from '../../../../utils/protocolUtils';
import { saveAs } from 'file-saver';

export interface DialogDataGenerateReport {
  protocol: ProtocolQ;
  toSign: boolean;
}

@Component({
    selector: 'app-protocol-q-edit-generate-report',
    templateUrl: './protocol-q-edit-generate-report.component.html',
    styleUrls: ['./protocol-q-edit-generate-report.component.scss'],
    standalone: false,
})
export class ProtocolQEditGenerateReportComponent implements OnInit, OnDestroy {

  respDocs: User[];
  reportConfig: ProtocolReportFilter;
  langs: LangFlag[];

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ProtocolQEditGenerateReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataGenerateReport,
    private protocolService: ProtocolQService,
    private usersService: UsersService,
    private translate: TranslateService,
    private translationService: TranslationService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) {

    if (data.toSign == null) {
      data.toSign = false;
    }

  }

  ngOnInit(): void {
    this.spinnerService.show();

    this.reportConfig = new ProtocolReportFilter();
    this.reportConfig.lang = this.translationService.currentLang;
    this.reportConfig.toSign = this.data.toSign;

    this.langs = this.translationService.configuredLangs;

    this.usersService.findAllUserToSignFromGroup().pipe(takeUntil(this.destroy$)).subscribe((item: User[]) => {
      this.spinnerService.hide();
      this.respDocs = item;
    }, () => this.spinnerService.hide());

    if (this.data.protocol.idStatus === ProtocolStatus.FIRMADO) {
      this.spinnerService.show();

      this.protocolService.downloadPdfProtocolVersion(this.data.protocol).pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
        const name = ProtocolUtils.getNameForProtocolQualificates(this.data.protocol, this.translate);
        saveAs(res, name);
        this.spinnerService.hide();

        this.dialogRef.close();
      }, () => {
        this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.notFound') as string);
        this.spinnerService.hide();
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOkClick(): void {
    this.spinnerService.show();
    this.reportConfig.toSign = this.data.toSign;

    this.protocolService.downloadPdf(this.data.protocol.id, this.reportConfig).pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
      const name = ProtocolUtils.getNameForProtocolQualificates(this.data.protocol, this.translate);
      saveAs(res, name);
      this.spinnerService.hide();

      this.dialogRef.close();
    }, () => {
      this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.generic') as string);
      this.spinnerService.hide();
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }


}
